import { Flex, Text } from "@chakra-ui/react";

import ColoredTags from "../../companiesTable/shared/coloredTags";
import ColoredItem from "../../companiesTable/shared/coloredTags/ColoredItem";
import CardInfoItem from "../shared/CardInfoItem";
import InfoCardWrap from "../shared/InfoCardWrap";

const CompanyCardInfo = ({ item }) => {
  return (
    <Flex direction={"column"} rowGap={"8px"} w={"100%"}>
      <InfoCardWrap>
        <CardInfoItem title={"Stage"}>
          <Text>
            {item?.stage?.toLowerCase().includes("unknown") ? "" : item?.stage}
          </Text>
        </CardInfoItem>
        <CardInfoItem title={"Year"}>
          <Text>{item?.yearFounded}</Text>
        </CardInfoItem>
        <CardInfoItem title={"Tags"}>
          <ColoredTags data={item?.tags} />
        </CardInfoItem>
      </InfoCardWrap>
      <InfoCardWrap>
        <CardInfoItem title={"Raised"}>
          <Text>{item?.raisedInRound}</Text>
        </CardInfoItem>
        <CardInfoItem title={"HQ"}>
          <Flex align={"centre"} columnGap={"4px"} justify={"center"}>
            {item?.headQuarters?.city ? (
              <ColoredItem item={item?.headQuarters?.city} />
            ) : null}
            {item?.headQuarters?.state ? (
              <ColoredItem item={item?.headQuarters?.state} />
            ) : null}
            {item?.headQuarters?.country ? (
              <ColoredItem item={item?.headQuarters?.country} />
            ) : null}
          </Flex>
        </CardInfoItem>
      </InfoCardWrap>
    </Flex>
  );
};

export default CompanyCardInfo;
